"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const additionalBenefitsInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Additional benefits",
  },
  {
    name: "details",
    type: "longText",
    required: true,
    defaultValue:
      "Members of Ploom Club receive a personalised experience from start to finish. Plus you’ll enjoy great benefits such as:",
  },
  {
    name: "benefitsList",
    type: "list",
    required: true,
    subFields: [
      {
        name: "benefitsTitle",
        type: "string",
        required: true,
      },
      {
        name: "benefitsImage",
        type: "file",
        required: true,
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
    ],
    defaultValue: [
      {
        benefitsTitle: "Exclusive offers",
        benefitsImage:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F3e46fb8430fe462ab939ca10bbe34289",
      },
      {
        benefitsTitle: "Product pre-order",
        benefitsImage:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F3e46fb8430fe462ab939ca10bbe34289",
      },
      {
        benefitsTitle: "Free shipping",
        benefitsImage:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F3e46fb8430fe462ab939ca10bbe34289",
      },
      {
        benefitsTitle: "Free cleaning instore",
        benefitsImage:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F3e46fb8430fe462ab939ca10bbe34289",
      },
    ],
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("benefitsList");
      if (Array.isArray(items) && items.length > 4) {
        options.set("benefitsList", items.slice(0, 4));
        alert("You can add maximum 4 items");
      }
    },
  },
] as const satisfies Inputs;

export const AdditionalBenefitsComponent: RegisteredComponent = {
  name: "AdditionalBenefits",
  component: dynamic(async () =>
    withValidation(
      additionalBenefitsInputs,
      (await import("./AdditionalBenefits")).AdditionalBenefits,
      "AdditionalBenefits"
    )
  ),
  inputs: additionalBenefitsInputs,
};
